import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {

  subscription: Subscription;
  menuList:any = [];
  router: any;
  flag1: boolean = true;
  flag2: boolean = false;
  constructor(public service: HomeService) {
    // this.service.getMenuList().subscribe(
    //   data => { 
    //     this.menuList = data.resultInfo.moduleList; 
    //   }
    // );
  }
  
  activeClick1(){
      this.flag1 = true;
      this.flag2 = false;
  }  
  activeClick2(){
      this.flag2 = true;
      this.flag1 = false;
  }

  ngOnInit(): void {
  }

  gotoPage(itemInfo) {
    this.menuList.forEach(menuInfo => {
      menuInfo.class = '';
    });
    itemInfo.class = 'aActive';
  }

}
